<footer>
  <div class="bg-gray-100">
    <div class="mx-auto px-4 py-8 md:container md:px-1">
      <div>
        <div class="grid grid-cols-12 gap-x-0 lg:gap-x-5">
          <div class="col-span-12 pb-2 text-center lg:text-start">
            <img
              class="mx-auto h-8 lg:mx-0"
              src="assets/images/logo-hb-sm.webp"
              alt="happybeauty logo" />
          </div>
          <div class="col-span-1 lg:col-span-9"></div>
          <div></div>
          <div class="col-span-12 lg:col-span-6 lg:pr-8 2xl:col-span-5">
            <!-- <picture>
              <img
                class="mx-auto h-8 lg:mx-0 lg:h-auto"
                src="assets/images/logo-hb-sm.webp"
                alt="happybeauty logo" />
            </picture> -->
            <div
              class="mt-0 text-center text-sm font-semibold text-gray-700 lg:text-start">
              <i> Happybeauty Your Personalized Skincare Platform </i>
            </div>
            <div class="mt-4 text-center text-sm text-gray-400 lg:text-start">
              Happybeauty is a personalised skincare platform that recommends
              skincare/cosmetics products that are suitable for your skin. With
              our in house technology, we bridge the gap between online and
              real-world shopping experience of cosmetic/skincare products.
            </div>
          </div>
          <div
            class="col-span-12 mt-4 md:col-span-4 md:mt-8 lg:col-span-2 lg:mt-0 2xl:col-span-3 2xl:pl-20">
            <h3 class="text-base font-bold uppercase text-gray-700">
              Happybeauty Info
            </h3>
            <ul class="mt-2 space-y-2 text-sm text-gray-400">
              <li>
                <a class="hover:text-primary-md-dark" routerLink="/about"
                  >About Happybeauty</a
                >
              </li>
              <li>
                <a routerLink="/" class="hover:text-primary-md-dark"
                  >Beauty Blog</a
                >
              </li>
              <li>
                <a
                  routerLink="/user/happy-pay"
                  class="hover:text-primary-md-dark"
                  >Happy Pay</a
                >
              </li>
              <li>
                <a
                  href="https://merchant.happybeauty.com.sg/"
                  class="hover:text-primary-md-dark"
                  >Sell on Happybeauty</a
                >
              </li>
            </ul>
          </div>
          <div
            class="col-span-12 mt-4 md:col-span-4 md:mt-8 lg:col-span-2 lg:mt-0">
            <h3 class="text-base font-bold uppercase text-gray-700">Help</h3>
            <ul class="mt-2 space-y-2 text-sm text-gray-400">
              <li>
                <a routerLink="/faq" class="hover:text-primary-md-dark"
                  >How to Order</a
                >
              </li>
              <li>
                <a
                  routerLink="/term-condition"
                  class="hover:text-primary-md-dark"
                  >Term and Condition</a
                >
              </li>
              <li>
                <a
                  routerLink="/privacy-policy"
                  class="hover:text-primary-md-dark"
                  >Privacy Policy</a
                >
              </li>
            </ul>
          </div>
          <div
            class="col-span-12 mt-4 md:col-span-4 md:mt-8 lg:col-span-2 lg:mt-0">
            <h3 class="text-base font-bold uppercase text-gray-700">
              Customer Care
            </h3>
            <ul class="mt-2 space-y-2">
              <li class="items-center text-sm text-gray-400">
                <a [href]="'tel:+' + phoneNumber">
                  <fa-icon class="mr-3" [icon]="faPhone"></fa-icon>
                  <span class="hover:underline"
                    >+{{ phoneNumber.slice(0, 2) }}
                    {{ phoneNumber.slice(2) }}</span
                  >
                </a>
              </li>
              <li class="items-center truncate text-sm text-gray-400">
                <a href="mailto:support@beautybook.com">
                  <fa-icon class="mr-3" [icon]="faEnvelope"></fa-icon>
                  <span class="hover:underline"
                    >support@happybeauty.com.sg</span
                  >
                </a>
              </li>
            </ul>
            <div class="mt-6">
              <div class="text-base font-bold uppercase text-gray-700">
                Operational Time
              </div>
              <div class="mt-2 text-sm text-gray-400">
                Monday to Saturday except holidays 09.00 - 17.00
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-0 grid grid-cols-12 gap-x-0 md:mt-8 lg:mt-7 lg:gap-x-5 lg:pb-5">
        <div class="col-span-12 mt-6 md:my-0 lg:col-span-10">
          <div>
            <div class="text-base font-bold uppercase text-gray-700">
              SHIPPING COURIER
            </div>
            <div class="mt-3 flex items-center gap-x-5">
              <picture *ngFor="let shipping of shippingMethod">
                <img
                  class="h-4 lg:h-5"
                  [src]="'assets/images/courier/' + shipping.img"
                  alt="{{ shipping.alt }}" />
              </picture>
            </div>
          </div>
          <div class="col-span-12 mt-5 lg:col-span-10">
            <div class="text-base font-bold uppercase text-gray-700">
              PAYMENT METHOD
            </div>
            <div class="mt-3 flex flex-wrap gap-4">
              <picture *ngFor="let payment of paymentMethod">
                <img
                  class="h-4 lg:h-5"
                  [src]="'assets/images/payment-method/' + payment.image"
                  alt="{{ payment.alt }}" />
              </picture>
            </div>
          </div>
        </div>
        <div class="col-span-12 gap-x-0 lg:col-span-2 lg:gap-x-5">
          <div class="mt-6 w-full lg:mt-0 lg:w-full">
            <div class="text-base font-bold uppercase text-gray-700">
              Follow Us
            </div>
            <div class="mt-3">
              <ul
                class="flex flex-wrap gap-y-4 gap-x-8 lg:grid-cols-1 lg:gap-y-2">
                <li *ngFor="let social of socialMedia">
                  <a
                    class="flex items-center"
                    [href]="social.link"
                    target="_blank">
                    <img
                      class="mr-3 h-5"
                      [src]="social.image"
                      alt="{{ social.alt }}" />
                    <div class="text-base hover:underline">
                      {{ social.name }}
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-gray-300">
    <div class="container mx-auto py-2 text-center text-xs md:text-sm">
      <span class="text-gray-700">
        2020-2022
        <fa-icon [icon]="faCopyright"></fa-icon> Happybeauty Singapore - All
        Rights Reserved
      </span>
    </div>
  </div>
</footer>
